/**
 * @generated SignedSource<<181a6b4609da78c2ffdbf472ec3fd70f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FinishLessonPlayInput = {
  lessonPlayId: string;
};
export type LessonAnswerFinishMutation$variables = {
  input: FinishLessonPlayInput;
};
export type LessonAnswerFinishMutation$data = {
  readonly finishLessonPlay: {
    readonly id: string;
  };
};
export type LessonAnswerFinishMutation = {
  response: LessonAnswerFinishMutation$data;
  variables: LessonAnswerFinishMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "LessonPlay",
    "kind": "LinkedField",
    "name": "finishLessonPlay",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LessonAnswerFinishMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "LessonAnswerFinishMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "7023d87a8e4da9262ca8b529334a5680",
    "id": null,
    "metadata": {},
    "name": "LessonAnswerFinishMutation",
    "operationKind": "mutation",
    "text": "mutation LessonAnswerFinishMutation(\n  $input: FinishLessonPlayInput!\n) {\n  finishLessonPlay(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "062c08918bd999a27d401ce23a991f6d";

export default node;
